export interface Viaje {
    id: number;
    numero: number;
    sector: string;
    idsector: number;
    fecha: Date;
    idtractor: number;
    idsemi: number;
    idpersonal: number;
    std: string;
    kmsstd: number;
    kminicial: number;
    kmfinal: number;
}

export class Regreso {
    idequipo: number;
    idviaje: number;
    kmfinal: number;
    litrosformula: string;
    litros: number;
    observacion: string;
    sincronizado: boolean;
    errorSincro: string;
    fechaSincro: string;
    imageData: string;
    imageData2: string;
}

export class RespuestaRegreso {
    idviaje: number;
    error: boolean;
    msjError: string;
}




// WEBPACK FOOTER //
// ./src/models/viaje.ts